import { compose, branch, renderNothing } from 'recompose'
import scriptLoader from '../../lib/async-loader'
import withSettings from '../../modules/config/withSettings'

export default compose(
  withSettings('REACT_APP_GOOGLE_MAPS_API_KEY'),
  scriptLoader(props => [
    `https://maps.googleapis.com/maps/api/js?key=${
      props.REACT_APP_GOOGLE_MAPS_API_KEY
    }&v=3.exp&language=en&libraries=geometry,drawing,places`
  ]),
  branch(props => !props.isScriptLoaded, renderNothing)
)



// WEBPACK FOOTER //
// ./src/services/maps/withGoogleAPI.js